module.exports = __webpack_public_path__ + "img/userTraining.79a70404.svg";